<template>
  <div class="base-layout-header-inner">
    <a-icon
      class="trigger"
      :type="collapsed ? 'menu-unfold' : 'menu-fold'"
      @click="SET_COLLAPSED(!collapsed)"
    />
    <a-dropdown class="header-right">
      <a class="right-dropdown-link" @click="e => e.preventDefault()">
        <a-avatar :src="logoUrl"></a-avatar>
        <span class="username">{{ username }}</span>
      </a>
      <a-menu slot="overlay" @click="handleDropdown">
        <!-- <a-menu-item key="0">
          <a href="https://password.lenovo.com/Index.aspx" target="_blank">
            <a-icon type="unlock" />
            <span style="margin-left:10px">修改密码</span>
          </a>
        </a-menu-item> -->
        <!-- <a-menu-divider /> -->
        <a-menu-item key="1">
          <a-icon type="logout" />
          退出登录
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <!-- 修改密码弹窗 -->
    <!-- <a-modal
      title="修改密码"
      :visible="visible"
      :confirm-loading="confirmLoading"
      cancelText="取消"
      okText="确定"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="visible = false"
    >
      <div>
        <a-form
          :form="passwordForm"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 19 }"
          @submit="handleSubmit"
        >
          <a-form-item label="原密码">
            <a-input-password
              v-decorator="$decorator('oldPassword', '原密码不能为空')"
            />
          </a-form-item>
          <a-form-item label="新密码">
            <a-input-password
              v-decorator="
                $decorator('password', '新密码不能为空', [
                  {
                    validator: validateToNextPassword
                  }
                ])
              "
            />
          </a-form-item>
          <a-form-item label="确认密码">
            <a-input-password
              v-decorator="
                $decorator('confirmPassword', '确认密码不能为空', [
                  {
                    validator: validateConfirmPassword
                  }
                ])
              "
              @blur="handleConfirmBlur"
            />
          </a-form-item>
        </a-form>
      </div>
    </a-modal> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { CLEAR_USER_INFO } from 'config/mutation-types/user'
import { logout, modifyPassword } from '@/layout/api'
import { SET_COLLAPSED } from 'config/mutation-types/app'

export default {
  beforeCreate() {
    this.passwordForm = this.$form.createForm(this)
  },
  data() {
    return {
      confirmLoading: false,
      visible: false,
      confirmDirty: false,
    }
  },
  computed: {
    ...mapGetters('user', ['username']),
    ...mapGetters('app', ['collapsed', 'logoUrl']),
  },
  methods: {
    ...mapMutations('user', [CLEAR_USER_INFO]),
    ...mapMutations('app', [SET_COLLAPSED]),

    handleDropdown({ key }) {
      this.loading = false
      if (key === '1') {
        this.$confirm({
          title: '提示',
          content: '确定要退出系统？',
          okButtonProps: {
            loading: this.loading,
          },
          cancelText: '取消',
          okText: '确定',
          onOk: () => {
            this.loading = true
            return this.signOut()
          },
        })
        // this.$router.push(
        //   'https://stscn.lenovo.com/adfs/ls/?wa=wsignoutcleanup1.0'
        // )
      }
    },
    signOut(isMessage = true) {
      return logout(isMessage).then(({ message }) => {
        if (isMessage) {
          this.$notification.success({
            message: '提示',
            description: message,
          })
        }
        this.CLEAR_USER_INFO()
        // window.open('https://stscn.lenovo.com/adfs/ls/?wa=wsignoutcleanup1.0')
        this.$router.push({ path: '/loginOut' })
      })
    },
    handleOk(e) {
      e.preventDefault()
      this.passwordForm.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          try {
            this.confirmLoading = true
            const { message } = await modifyPassword(values)

            this.$notification.success({
              message: '提示',
              description: message,
            })
            this.confirmLoading = false
            return this.signOut(false)
          } catch (e) {
            this.confirmLoading = false
          }
        }
      })
    },
    handleSubmit() {},
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.passwordForm
      if (value && this.confirmDirty) {
        form.validateFields(['confirmPassword'], { force: false })
      }
      callback()
    },
    validateConfirmPassword(rule, value, callback) {
      const form = this.passwordForm
      const password = form.getFieldValue('password')

      if (value && value !== password) {
        callback('两次密码不一致')
      } else {
        callback()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.base-layout-header-inner {
  height: 100%;

  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .header-right {
    float: right;
    margin-right: 50px;
    padding: 0 10px;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }

    .username {
      margin-left: 10px;
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
    }
  }
}
</style>
